import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "a",
      width: "24",
      height: "24",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"alpha"}
    }, [
      _createElementVNode("path", {
        fill: "#D9D9D9",
        d: "M0 0h24v24H0z"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#114A4E",
        d: "m7.625 6.4 2.8-3.625q.3-.4.712-.587Q11.55 1.999 12 2q.45 0 .863.188.412.186.712.587l2.8 3.625 4.25 1.425q.65.2 1.025.737.375.538.375 1.188 0 .3-.087.6-.089.3-.288.575l-2.75 3.9.1 4.1q.025.875-.575 1.475t-1.4.6q-.05 0-.55-.075L12 19.675l-4.475 1.25a1 1 0 0 1-.275.063Q7.1 21 6.975 21q-.8 0-1.4-.6T5 18.925l.1-4.125-2.725-3.875a1.9 1.9 0 0 1-.288-.575Q2 10.05 2 9.75q0-.625.362-1.162.363-.538 1.013-.763zM8.85 8.125 4 9.725 7.1 14.2 7 18.975l5-1.375 5 1.4-.1-4.8L20 9.775l-4.85-1.65L12 4z"
      })
    ], -1)
  ])))
}
export default { render: render }